import script from "./EventViewChatPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventViewChatPage.vue?vue&type=script&setup=true&lang=ts"

import "./EventViewChatPage.vue?vue&type=style&index=0&id=2f289574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f289574"]])

export default __exports__